<template>
  <v-row>
    <v-dialog
      v-model="preview_dialog_ref"
      fullscreen
      hide-overlay
      transition="dialog-top-transition"
    >
      <v-card>
        <v-toolbar dark color="primary lighten-2">
          <v-btn icon dark @click="dialogClose()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Preview</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items> </v-toolbar-items>
        </v-toolbar>
        <v-main class="grey lighten-3" style="height: 91%; padding: 16px 0px 0px !important">
          <v-container>
            <v-row>
              <v-col cols="12" sm="12">
                <v-card class="mx-auto" height="100%">
                  <v-toolbar color="#27282A"  flat>
                    <v-img
                      lazy-src="@/assets/logo.png"
                      
                      height="45"
                      max-height="45"
                      min-height="45"
                      contain
                      aspect-ratio="1"
                      v-bind:src="imgr"
                    ></v-img>
                    <v-toolbar-title> </v-toolbar-title>
                    <v-spacer class="d-none d-lg-block"></v-spacer
                    ><v-spacer class="d-none d-lg-block"></v-spacer
                    ><v-spacer class="d-none d-lg-block"></v-spacer>
                    <v-spacer v-if="button2.show"></v-spacer>
                    <v-spacer v-if="button2.show"></v-spacer>
                    <v-spacer v-if="!button2.show && button1.show"></v-spacer>
                    <v-btn
                      v-if="button1.show"
                      color="#27282A"
                      style="color:#fff;font-size:14pt;font-family:'Open Sans'"
                      class="mr-4"
                      @click="buttonInfo(button1)"
                      >{{ button1.label }}</v-btn
                    >
                    <v-btn
                      v-if="button2.show"
                      color="#27282A"
                      style="color:#fff;font-size:14pt;font-family:'Open Sans'"
                      class=""
                      @click="buttonInfo(button2)"
                      >{{ button2.label }}</v-btn
                    >
                  </v-toolbar>
                  <v-container fluid>
                    <v-row>
                      <v-col cols="12">
                        <br><h2 style="color:#07293d;font-family:'Open Sans Bold';position:relative;" class="text-center">{{former.title}}</h2>
                    <div class="text-center" style="position:relative;top:12px;font-weight:400;color:#07293d">{{former.description}}</div>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <SearchIndex v-bind:client="client" v-bind:mode="'preview'" />
                      </v-col>
                    </v-row>
                    <v-row v-model="cards">
                      <v-col
                        id="sortable"
                        v-for="(card, idx) in cards"
                        :key="card.id"
                        :cols="computeColumns(card.flex, idx)"
                      >
                        <v-card
                          height="100%"
                          :class="card.bubba_class"
                        >
                          <v-img
                            v-if="card.include_gradient"
                            :src="card.src"
                            :class="card.bubba_class"
                            class="blue accent-1"
                            :height="75"
                          >
                            <v-card-title v-text="card.title"></v-card-title>
                          </v-img>
                          <v-img v-else>
                            <v-card-title v-text="former.title"></v-card-title>
                            <v-card-subtitle
                              v-text="former.description"
                            ></v-card-subtitle>
                          </v-img>

                          <v-list :dense="contentLength(card) > 6">
                            <v-subheader>{{ card.description }}</v-subheader>
                            <v-list-item-group
                              v-model="selected_content"
                              color="primary"
                            >
                              <v-list-item
                                v-for="(contenter, index) in card.content"
                                :key="getKey(card.id, contenter.id)"
                                :value="getCardKey(card.id, contenter)"
                              >
                                <v-list-item-icon v-if="(index+1) <= categoryBreakpoint()">
                                  <v-icon
                                    color="primary"
                                    v-text="computedIcon(contenter.type)"
                                  ></v-icon>
                                </v-list-item-icon>
                                <v-list-item-content v-if="(index+1) <= categoryBreakpoint()">
                                  <v-list-item-title
                                    v-text="contenter.title"
                                  ></v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-content v-if="(index+1) == categoryBreakpoint()+1 && contentLength(card)>categoryBreakpoint()">
                                  <v-list-item-title
                                    v-text=" 
                                      'And ' +
                                      (contentLength(card) - (index)) +
                                      ' more...'
                                    "
                                  ></v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                            </v-list-item-group>
                          </v-list>

                          <v-card-actions v-if="card.include_footer">
                            <v-spacer></v-spacer>
                            <v-btn icon>
                              <v-icon>mdi-heart</v-icon>
                            </v-btn>
                            <v-btn icon>
                              <v-icon>mdi-bookmark</v-icon>
                            </v-btn>
                            <v-btn icon>
                              <v-icon>mdi-share-variant</v-icon>
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-main>
        <KnowledgeBaseFooter
        v-bind:former="former"
        v-bind:imgr="imgr"/>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import SearchIndex from "./SearchIndex.vue";
import KnowledgeBaseFooter from "./KnowledgeBaseFooter.vue";
import kbMixin from "./KnowledgeBaseMixin.js";
import { ApolloClient, InMemoryCache } from "@apollo/client/core";

export default {
  components: {
    SearchIndex,
    KnowledgeBaseFooter
  },
  mounted() {
    let self = this;
    this.$cognitoAuth.getIdToken((err, idToken) => {
      if (err) {
        console.error("App: Couldn't get the session:", err, err.stack);
        return;
      }
      self.idToken = idToken;
    });
    this.client = new ApolloClient({
      uri: `${process.env.VUE_APP_GRAPHQL_HTTP}`,
      cache: new InMemoryCache(),
      headers: {
        authorization: `Bearer ${self.idToken}`,
      },
    });
  },
  mixins: [kbMixin],
  props: ["fully", "imgr", "former","preview_dialog", "button1", "button2", "cards"],
  data() {
    return {
      preview_dialog_ref:false,
      client: {},
      idToken: "",
      selected_content: "",
      dialog: false,
      notifications: false,
      sound: true,
      widgets: false,
    };
  },
  watch: {
    preview_dialog(valzer){
      this.preview_dialog_ref=valzer;
    },
    selected_content(valzer) {
      console.log(valzer);
      this.dialog = false;
      if (valzer.type != undefined) {
        window.open(
          `/kbs/v/${this.$route.params.id}/${valzer.category_id}/${valzer.content_id}`
        );
      } else {
        window.open(`/kbs/kb/${this.model.id}`);
      }
    },
  },
  computed: {
    mobile() {
      return (this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs);
    },
    medium() {
      return this.$vuetify.breakpoint.md;
    },
    large() {
      return (this.$vuetify.breakpoint.lg ||this.$vuetify.breakpoint.xl) ;
    },
    
  },
  methods: {
    dialogClose(){
      this.preview_dialog_ref=false;
      this.$emit("dialogCloser", false);
    },
    categoryBreakpoint(){
      if(this.mobile){
        return 3
      }else if(this.medium){
        return 4
      }else if(this.large){
        return 5
      }else{
        return 4
      }
    },
    /*eslint-disable no-unused-vars */
    computeHeight(height, idx) {
      if (this.cards.length < 4) {
        return "100%";
      } else {
        return height;
      }
    },
    /*eslint-disable no-unused-vars */
    computeColumns(flex, idx) {
      switch (this.cards.length) {
        case 1:
          return 12;
        case 2:
        case 4:
          return 6;
        case 3:
        case 6:
          return 4;
        default:
          return 12;
      }
    },
    computedIcon(type) {
      if (type == "tutorial") {
        return "mdi-book-play";
      } else if (type == "quiz") {
        return "mdi-check-decagram-outline";
      } else {
        return "mdi-flag";
      }
    },
    buttonInfo: function (button) {
      window.open(button.link, "_blank");
    },
    contentLength(card) {
      if (card.content) {
        return card.content.length;
      } else {
        return 0;
      }
    },
  },
};
</script>